import React from 'react';

import { formatDefaultDateAndTime } from '../../utils/utils';

export type DateTimeShortProps = {
  dateTime: string | number; // expects an ISO-8601 date string or a timestamp
};

export const DateTimeShort = React.memo(function DateTimeShort(props: DateTimeShortProps) {
  const date = formatDefaultDateAndTime(props.dateTime);
  return <time dateTime={date}>{date}</time>;
});
